import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';
import { EventWithLabel } from '~shared/modules/seo/constants';

export class SeoFaqToggleApplicationEvent implements ApplicationEvent {
  type = ApplicationEventType.SeoFaqToggle;

  constructor(private label: string) {}

  getPayload(): EventWithLabel {
    return {
      label: this.label,
    };
  }
}
